import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WebsocketRequest, WebsocketService } from "./websocket";

/* eslint-disable @typescript-eslint/naming-convention */
export interface JSONRpcRequestData {
    uuid: string;
    raw_body_content: {
        [key: string]: any;
    };
}

export interface JSONRpcRequest extends WebsocketRequest {
    json_rpc_data: JSONRpcRequestData;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface JSONRpcValidResponse {
    jsonrpc: string;
    result: any;
}

export interface JSONRpcErrorResponse {
    jsonrpc: string;
    error: Record<string, any>;
}

export type JSONRpcResponse = JSONRpcValidResponse | JSONRpcErrorResponse;

@Injectable({
    providedIn: "root",
})
export class JSONRpcDatabaseService {
    private requestType = "jsonrpc";
    private secureRequestType = "jsonrpc_claretoken";

    constructor(private websocket: WebsocketService) {}

    public makeJSONRpcRequest$(uuid: string, method: string, params: any[] = []): Observable<JSONRpcResponse> {
        /* eslint-disable @typescript-eslint/naming-convention */
        const data: JSONRpcRequestData = { uuid, raw_body_content: { jsonrpc: "2.0", method, params } };
        return this.websocket.makeRequest({
            request_type: this.requestType,
            json_rpc_data: data,
            metadata: {},
        } as JSONRpcRequest);
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    public makeSecureJSONRpcRequest$(uuid: string, method: string, params: any[] = []): Observable<JSONRpcResponse> {
        /* eslint-disable @typescript-eslint/naming-convention */
        const data: JSONRpcRequestData = {
            uuid,
            raw_body_content: { jsonrpc: "2.0", method, params, clareToken: `<<secure_token_placeholder>>` },
        };
        return this.websocket.makeRequest({
            request_type: this.secureRequestType,
            json_rpc_data: data,
            metadata: {},
        } as JSONRpcRequest);
        /* eslint-enable @typescript-eslint/naming-convention */
    }
}
